export const languageOptions = {
  en: "us",
  de: "de",
  fr: "fr",
  cn: "cn",
  be: "be",
  nl: "nl",
  it: "it",
  dk: "dk",
  pl: "pl",
  sk: "sk",
  si: "si",
  at: "at",
  lu: "lu",
  cz: "cz",
};
